export const status = {
  DRAWING: '框选',
  MOVING: '移动',
  UPDATING: '更新',
  DEFAULT: 'DEFAULT'
}
